(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureSectionBlockEditController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', 'procedureService', 'notificationService', 'attachmentService', 'marked', 'modalService', '$modal', 'languageService'];

    function Controller($scope, $timeout, $state, procedureService, notificationService, attachmentService, marked, modalService, $modal, languageService) {
        /** @property sectionBlock comes from parent scope */
        $scope.languageService = languageService;

        $scope.sectionCtxtCtrl = {
            isLoading: false,
            isTitleRequired: $scope.sectionBlock.Depth < 2,

            // Collapse/expand references
            showReferences: false,

            // References
            lookupReferences: {
                GlossaryTerm: [],
                ProcessOutput: []
            },

            // Number of references
            referenceCount: 0,

            // Used to provide temporary ID for new objects passed as reference. Allows to remove them from the list.
            tempRefId: 0,

            // Warnings and errors from markdown content
            messagesEN: [],
            messagesFR: [],
            showErrors: false,

            // Helpers to indicate if content is copied from English or translated
            isTitleFromEnglish: false,
            isContentFromEnglish: false,

            langIdEN: _.find($scope.sectionBlockLookups.Language.LookupAttributeValues, {Value: 'EN'}).LookupAttributeValueID,
            langIdFR: _.find($scope.sectionBlockLookups.Language.LookupAttributeValues, {Value: 'FR'}).LookupAttributeValueID
        };
        $scope.procedureCtxt = $scope.ctxtCtrl;

        var sectionBlockLookupsByAttributeID = {};

        _.forOwn($scope.sectionBlockLookups, function (lookupAttribute) {
            sectionBlockLookupsByAttributeID[lookupAttribute.LookupAttributeID] = lookupAttribute;
        });

        var renderer            = new marked.Renderer();
        var defaultTextRenderer = renderer.text;

        // Disable headings for section blocks
        renderer.heading = function (text) {
            return text;
        };

        // Display images centered and with their title under
        renderer.image = function (href, title, text) {
            var out = '<p class="image-block"><img attachment-img data-attachment-id="' + href + '" alt="' + text + '"';

            if (title) {
                out += ' title="' + title + '"'
          }

          var maxLength = 250;
          if (text.length > maxLength) {
            $scope.procedureSectionBlockForm.$setValidity('ValidMarkdown', false);
            $scope.sectionCtxtCtrl['messages' + $scope.ctxtCtrl.lang].push({
              type: 'error',
              content: 'The text between the [ ] of an image must be shorter than ' + maxLength
                + ' (currently ' + text.length + ')'
            });
          }

          out += ' /><span class="image-title">' + text + '</span></p>';
          return out;
        };

        // Manage custom tags
        renderer.link = function (href, title, text) {

            // Url
            var urlRegex   = new RegExp(/^((https?):[^\s\]\)]*)$/gi);
            var urlMatches = urlRegex.exec(href);
            if (urlMatches) {
                return renderUrl(href, title, text);
            }

            // Footnote
            var footnoteRegex   = new RegExp(/^((Footnote):(.+))$/g);
            var footnoteMatches = footnoteRegex.exec(href);
            if (footnoteMatches) {
                var footnoteContent = footnoteMatches[3]
                return renderFootnote(footnoteContent, text)
            }

            // Inline references
            var refRegex   = new RegExp(/^((BusinessUnit|Committee|CorporateRole|GlossaryTerm|IAMSystem|Responsibility|Section|Procedure):([0-9]+))$/g);
            var refMatches = refRegex.exec(href);
            if (refMatches) {
                var entity   = refMatches[2];
                var entityId = refMatches[3];
                return renderReference(entity, entityId, text)
            }

            // Not a custom tag, treat as text
            return defaultTextRenderer.call(renderer, '[' + text + '](' + href + ')');
        };

        function renderUrl(href, title, text) {
            // Manage error when no visible text
            if (!text || !text.trim().length) {
                $scope.sectionCtxtCtrl['messages' + $scope.ctxtCtrl.lang].push({
                    type: 'error',
                    content: 'Url \'' + href + '\' must have a text between the [ ]'
                });
                $scope.procedureSectionBlockForm.$setValidity('ValidMarkdown', false);
            }

            var maxLength = 250;
            if (text.length > maxLength) {
                $scope.procedureSectionBlockForm.$setValidity('ValidMarkdown', false);
                $scope.sectionCtxtCtrl['messages' + $scope.ctxtCtrl.lang].push({
                    type: 'error',
                    content: 'The text between the [ ] of a URL must be shorter than ' + maxLength
                    + ' (currently ' + text.length + ')'
                });
            }

            maxLength = 500;
            if (href.length > maxLength) {
                $scope.procedureSectionBlockForm.$setValidity('ValidMarkdown', false);
                $scope.sectionCtxtCtrl['messages' + $scope.ctxtCtrl.lang].push({
                    type: 'error',
                    content: 'The length of a URL must be shorter than ' + maxLength
                    + ' (currently ' + href.length + ')'
                });
            }

            return customLinkRenderer.apply(renderer, arguments);
        }

        /*
            Based on the code taken from the sources of the library, adds 'target="_blank"'
         */
        function customLinkRenderer(href, title, text) {
            if (this.options.sanitize) {
                try {
                    var prot = decodeURIComponent(unescape(href))
                        .replace(/[^\w:]/g, '')
                        .toLowerCase();
                } catch (e) {
                    return '';
                }
                if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
                    return '';
                }
            }
            var out = '<a href="' + href + '" target="_blank"';

            if (title) {
                out += ' title="' + title + '"';
            }

            out += '>' + text + '</a>';
            return out;
        }

        function renderFootnote(footnoteContent, text) {
            var footnotePath = "sectionBlock.inlineReferences.Footnote['" + text + "']";

            addFootnote(text, footnoteContent);

            var maxLength = 250;
            if (text.length > maxLength) {
                $scope.procedureSectionBlockForm.$setValidity('ValidMarkdown', false);
                $scope.sectionCtxtCtrl['messages' + $scope.ctxtCtrl.lang].push({
                    type: 'error',
                    content: 'The text between the [ ] of a footnote must be shorter than ' + maxLength
                    + ' (currently ' + text.length + ')'
                });
            }

            // ex: <sup><a prc-footnote-ref
            //             footnote="sectionBlock.inlineReferences.Footnote['shortName']"
            //             footnote-name="text">[text]</a></sup>
            return '<sup><span prc-footnote-ref ' +
                'footnote="' + footnotePath + '" ' +
                'footnote-name="' + encodeURI(text) + '">[<span style="color: #337AB7">' + text + '</span>]</span></sup>';
        }

        function renderReference(entity, entityId, text) {
            var entityPath = "sectionBlock.inlineReferences." + entity + "['" + entityId + "']";

            // Manage error when no visible text
            if (!text || !text.trim().length) {
                $scope.sectionCtxtCtrl['messages' + $scope.ctxtCtrl.lang].push({
                    type: 'error',
                    content: _.startCase(entity) + ' (ID: ' + entityId + ') must have a text between the [ ]'
                });
                $scope.procedureSectionBlockForm.$setValidity('ValidMarkdown', false);
            }

            /*
             * ex: <span prc-inline-ref style="border-bottom:1px dotted #707070" title="Committee"
             *           entity="sectionBlock.inlineReferences.Committee['230']"
             *           entity-type="Committee"
             *           visible-text="text">text</span>
             */
            return '<span style="border-bottom:1px dotted #707070" title="' + entity + '" prc-inline-ref ' +
                'entity="' + entityPath + '" ' +
                'entity-type="' + entity + '" ' +
                'visible-text="' + encodeURI(text) + '">' + text + '</span>';
        }

        function getLangPrefix() {
            return $scope.ctxtCtrl.lang === 'EN' ? '' : $scope.ctxtCtrl.lang;
        }

        function displayCannotDeleteModal(references) {
            modalService.displayTemplateModal(
                'References to this Procedure',
                require('../../../shared/procedure/prcCannotDeleteProcedure.modal.tpl.html'),
                {
                    ngStyle: {
                        'min-height': '0'
                    },
                    references: references,
                    getUrl: function (reference) {
                        return '/Procedure/'
                            + reference.ProcedureTypeValue
                            + '/' + reference.ProcedureCodeFull
                            + '/Published#' + reference.Anchor
                    }
                },
                true,
                false
            );
        }

        // Language Changed
        $scope.setLanguage = function (langAttr) {
            $scope.ctxtCtrl.langAttr = langAttr;
            $scope.ctxtCtrl.lang = langAttr.Value;

            // Default content from english
            if (langAttr.Value !== 'EN') {
                // Title
                if (!$scope.sectionBlock['Title' + $scope.ctxtCtrl.lang] && $scope.sectionBlock.TitleEN) {
                    $scope.sectionBlock['Title' + $scope.ctxtCtrl.lang] = $scope.sectionBlock.TitleEN;
                    $scope.sectionCtxtCtrl.isTitleFromEnglish           = true;
                    $scope.procedureCtxt.hasSectionChanged              = true;
                }

                // Content
                if (!$scope.sectionBlock['Content' + $scope.ctxtCtrl.lang] && $scope.sectionBlock.Content) {
                    $scope.sectionBlock['Content' + $scope.ctxtCtrl.lang] = $scope.sectionBlock.Content;
                    $scope.sectionCtxtCtrl.isContentFromEnglish           = true;
                    $scope.procedureCtxt.hasSectionChanged                = true;
                }
            } else {
                // Reset french fields?
                if ($scope.sectionCtxtCtrl.isTitleFromEnglish && $scope.sectionCtxtCtrl.isContentFromEnglish) {
                    delete $scope.sectionBlock.TitleFR;
                    delete $scope.sectionBlock.ContentFR;
                    delete $scope.sectionBlock.ContentHtmlFR;
                }
            }

            $scope.updateContent({skipSetDirty: true});
        };

        // Title Changed
        $scope.titleChanged = function () {
            $scope.procedureCtxt.hasSectionChanged = true;

            if ($scope.ctxtCtrl.lang !== 'EN') {
                $scope.sectionCtxtCtrl.isTitleFromEnglish = false;
            }

            updateFormValidity();
        };

        /**
         * Parse the markdown, render custom content and update model accordingly
         * @param [args] {object} provide parameters
         * @param [args.content] {string} content to use to update the model
         * @param args.skipSetDirty {boolean=false} true to prevent marking the section as changed
         */
        $scope.updateContent = function (args) {
            args = args || {};

            if (args.content) {
                $scope.sectionBlock['Content' + getLangPrefix()] = args.content;
            }

            $scope.sectionCtxtCtrl['messages' + $scope.ctxtCtrl.lang] = [];

            if ($scope.procedureSectionBlockForm) {
                $scope.procedureSectionBlockForm.$setValidity('ValidMarkdown', true);
            }

            if (!args.skipSetDirty) {
                $scope.procedureCtxt.hasSectionChanged = true;

                if ($scope.ctxtCtrl.lang !== 'EN') {
                    $scope.sectionCtxtCtrl.isContentFromEnglish = false;
                }
            }

            $scope.sectionBlock['Footnotes' + $scope.procedureCtxt.lang] = [];
            var langPrefix = getLangPrefix();

            if ($scope.sectionBlock['Content' + langPrefix]) {
                $scope.sectionBlock['ContentHtml' + langPrefix] = marked(
                    $scope.sectionBlock['Content' + langPrefix],
                    {renderer: renderer}
                );
            } else {
                $scope.sectionBlock['ContentHtml' + langPrefix] = null;
            }

            updateFormValidity();
        };

        // Create or Update
        $scope.createOrUpdate = function () {
            if ($scope.sectionCtxtCtrl.isLoading) return;

            if ($scope.procedureSectionBlockForm.$invalid) {
                // Prevents messing with the timeout
                if ($scope.sectionCtxtCtrl.showErrors) return false;

                $scope.sectionCtxtCtrl.showErrors = true;

                $timeout(function () {
                    $scope.sectionCtxtCtrl.showErrors = false;
                }, 5000);

                return false;
            }

            $scope.sectionCtxtCtrl.isLoading = true;
            $scope.sectionCtxtCtrl.listErrors = null;

            var promise;
            var successMessage;

            procedureService
                .validateTranslationSectionBlock($scope.procedure.MetadataBlock.ProcedureType.Value, $scope.sectionBlock)
                .then(function (listErrors) {

                    if (listErrors.length > 0) {
                        notificationService.warn('There were translation errors, view messages');

                        $scope.sectionCtxtCtrl.listErrors = listErrors;

                        var $el = $('#sectionBlockContent' + $scope.procedureCtxt.lang);
                        window.scrollTo(0, $el.offset().top - 60);
                        return;
                    }

                    // Create/Update
                    if ($scope.sectionBlock.SectionBlockID) {
                        promise = procedureService.updateSectionBlock(
                            $scope.procedure.MetadataBlock.ProcedureType.Value,
                            $scope.procedure.ProcedureID,
                            $scope.sectionBlock);
                        successMessage = 'Section updated with success';
                    } else {
                        var sectionBlockIds = $scope.getAllSectionBlockIDs();
                        promise = procedureService.createSectionBlock(
                            $scope.procedure.MetadataBlock.ProcedureType.Value,
                            $scope.procedure.ProcedureID,
                            $scope.sectionBlock,
                            sectionBlockIds);
                        successMessage = 'Section created with success';
                    }

                    return promise
                        .then(function (updatedSectionBlock) {
                            $scope.procedureCtxt.hasSectionChanged = false;
                        $scope.finishedEditing(updatedSectionBlock);
                        notificationService.notify(successMessage);

                            manageProcedureVersionChanged(updatedSectionBlock);
                        });
                })
                .finally(function () {
                    $scope.sectionCtxtCtrl.isLoading = false;
                });
        };

        // Cancel
        $scope.cancel = function () {
            $scope.cancelEdition();
        };

        // Delete
        $scope.deleteSection = function () {
            $scope.sectionCtxtCtrl.isLoading = true;
            procedureService
                .checkIfCanSafelyDeleteSectionBlock(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.sectionBlock.SectionBlockID
                )
                .then(function (references) {
                    if (references.length) {
                        displayCannotDeleteModal(references);

                        return $q.reject();
                    }

                    return procedureService
                        .deleteSectionBlock(
                            $scope.procedure.MetadataBlock.ProcedureType.Value,
                            $scope.procedure.ProcedureID,
                            $scope.sectionBlock
                        );
                })
                .then(function (deletedSectionBlock) {
                    var deletedStatus = _.get(deletedSectionBlock, 'ProgressStatus.Value', null);

                    // Section pending Deletion Review
                    if (deletedStatus === 'ReviewDeletion') {
                        $scope.procedureCtxt.hasSectionChanged = false;
                        $scope.finishedEditing(deletedSectionBlock);
                        notificationService.notify('Section is pending deletion review');
                        manageProcedureVersionChanged(deletedSectionBlock)
                        return;
                    }

                    // Section Deleted
                    $scope.cancelEdition();
                    $scope.removeSectionBlock($scope.sectionBlock);
                    notificationService.notify('Section deleted with success');
                })
                .finally(function () {
                    $scope.sectionCtxtCtrl.isLoading = false;
                });
        };

        // Get participants to assign a Responsibility
        $scope.getParticipants = function () {
            var participants = {};

            if ($scope.sectionBlock.CommitteeReferences.length > 0) {
                participants.Committee = $scope.sectionBlock.CommitteeReferences;
            }
            if ($scope.sectionBlock.CorporateRoleReferences.length > 0) {
                participants.CorporateRole = $scope.sectionBlock.CorporateRoleReferences;
            }
            if ($scope.sectionBlock.BusinessUnitReferences.length > 0) {
                participants.BusinessUnit = $scope.sectionBlock.BusinessUnitReferences;
            }

            return participants;
        };

        // Add reference on the Section Block level
        $scope.addReference = function () {
            var modal = modalService.displayTemplateModal(
                'Select a Reference Type',
                require('../../../shared/procedure/referenceType/prcReferenceType.modal.tpl.html'),
                {
                    procedure: $scope.procedure,
                    lookupAttributes: $scope.sectionBlockLookups,
                    onAttachmentRefSelection: function () {
                        modal.$promise.then(modal.hide);
                        addAttachmentReference();
                    },
                    onControlRefSelection: function () {
                        modal.$promise.then(modal.hide);
                        addControlReference();
                    },
                    onLookupAttributeValueRefSelection: function (lookupAttribute) {
                        modal.$promise.then(modal.hide);
                        addLookupAttributeReference(lookupAttribute);
                    }
                },
                false
            );

            $scope.sectionCtxtCtrl.showReferences = true;
        };

        // When an image has been inserted
        $scope.onImageInserted = function (args) {
            args.uploadedFile.TitleEN = args.title;

            $scope.sectionBlock.ImageAttachments.push(args.uploadedFile);
            $scope.updateContent(args);
        };

        // Return the function called when inserting an image
        $scope.getImageInsertedFunc = function () {
            return $scope.onImageInserted;
        };

        // When business unit has been inserted in the content
        $scope.onBusinessUnitInserted = function (args) {
            $scope.updateContent(args);

            if (!_.find($scope.sectionBlock.BusinessUnitReferences, {
                    BusinessUnitID: args.businessUnit.BusinessUnitID
                })) {
                $scope.sectionBlock.BusinessUnitReferences.push(args.businessUnit);
            }
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getBusinessUnitInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertBusinessUnitReference) return null;
            return $scope.onBusinessUnitInserted;
        };

        // When Committee has been inserted in the content
        $scope.onCommitteeInserted = function (args) {
            $scope.updateContent(args);

            var foundCommittee = _.find($scope.sectionBlock.CommitteeReferences, {
                CommitteeID: args.committee.CommitteeID
            });

            if (!foundCommittee) {
                $scope.sectionBlock.CommitteeReferences.push(args.committee);
            }
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getCommitteeInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertCommitteeReference) return null;
            return $scope.onCommitteeInserted;
        };

        // When Corporate Role has been inserted in the content
        $scope.onCorpRoleInserted = function (args) {
            $scope.updateContent(args);

            var foundCorporateRole = _.find($scope.sectionBlock.CorporateRoleReferences, {
                CorporateRoleID: args.corporateRole.CorporateRoleID
            });

            if (!foundCorporateRole) {
                $scope.sectionBlock.CorporateRoleReferences.push(args.corporateRole);
            }
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getCorpRoleInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertCorporateRoleReference) return null;
            return $scope.onCorpRoleInserted;
        };

        // When footnote has been inserted in the content
        $scope.onFootnoteInserted = function (args) {
            $scope.updateContent(args);
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getFootnoteInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertFootnoteReference) return null;
            return $scope.onFootnoteInserted;
        };

        // When Glossary Term has been inserted in the content
        $scope.onGlossaryTermInserted = function (args) {
            $scope.updateContent(args);

            $scope.sectionCtxtCtrl.lookupReferences[$scope.sectionBlockLookups.GlossaryTerm.Code].push(args.glossaryTerm);

            // Update model
            $scope.sectionBlock.LookupReferences.push(args.glossaryTerm);

            updateReferences();
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getGlossaryTermInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertGlossaryTermReference) return null;
            return $scope.onGlossaryTermInserted;
        };

        // When IAM System has been inserted in the content
        $scope.onIAMSystemInserted = function (args) {
            $scope.updateContent(args);
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getIAMSystemInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertIAMSystemReference) return null;
            return $scope.onIAMSystemInserted;
        };
        // When responsibility has been inserted in the content
        $scope.onResponsibilityInserted = function (args) {
            $scope.updateContent(args);
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getResponsibilityInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertResponsibilityReference) return null;
            return $scope.onResponsibilityInserted;
        };

        // When section block has been inserted in the content
        $scope.onSectionInserted = function (args) {
            $scope.updateContent(args);
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getSectionInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertSectionBlockReference) return null;
            return $scope.onSectionInserted;
        };

        // When procedure has been inserted in the content
        $scope.onProcedureInserted = function (args) {
            $scope.updateContent(args);
        };

        // Return null if no permission, otherwise the function to call when inserted
        $scope.getProcedureInsertedFunc = function () {
            if (!$scope.procedure.HasSectionBlock_InsertInlineProcedureReference) return null;
            return $scope.onProcedureInserted;
        };

        // When an Url has been inserted in the content
        $scope.onUrlInserted = function (args) {
            $scope.updateContent(args);
        };

        // Return the function called when inserting an URL
        $scope.getUrlInsertedFunc = function () {
            return $scope.onUrlInserted;
        };

        // Get download attachment URL
        $scope.getDownloadAttachmentUrl = function (attachment) {
            return attachmentService.getDownloadUrl(attachment.AttachmentExternalID);
        };

        // Edit Attachment Reference
        $scope.editAttachmentReference = function (attachment) {
            addAttachmentReference(attachment);
        };

        // Remove Attachment Reference
        $scope.removeAttachmentReference = function (attachment) {
            $scope.sectionBlock.AttachmentReferences =
                _.reject($scope.sectionBlock.AttachmentReferences, {AttachmentID: attachment.AttachmentID});

            updateReferences();
        };

        // Remove Business Unit Reference
        $scope.removeBusinessUnitReference = function (businessUnit) {
            $scope.sectionBlock.BusinessUnitReferences =
                _.reject($scope.sectionBlock.BusinessUnitReferences, {BusinessUnitID: businessUnit.BusinessUnitID});

            updateReferences();
        };

        // Remove Control Reference
        $scope.removeControlReference = function (control) {
            $scope.sectionBlock.ControlReferences =
                _.reject($scope.sectionBlock.ControlReferences, {ControlID: control.ControlID});

            updateReferences();
        };

        // Remove Lookup Attribute Value Reference
        $scope.removeLookupReference = function (lookupAttribute, lookupAttributeValue) {
            $scope.sectionCtxtCtrl.lookupReferences[lookupAttribute.Code] =
                _.reject($scope.sectionCtxtCtrl.lookupReferences[lookupAttribute.Code], {
                    LookupAttributeValueID: lookupAttributeValue.LookupAttributeValueID
                });

            // Update model
            $scope.sectionBlock.LookupReferences = _.reject($scope.sectionBlock.LookupReferences, {
                LookupAttributeValueID: lookupAttributeValue.LookupAttributeValueID
            });

            updateReferences();
        };

        // Remove Procedure Reference
        $scope.removeProcedureReference = function (procedure) {
            $scope.sectionBlock.ProcedureReferences =
                _.reject($scope.sectionBlock.ProcedureReferences, {ProcedureID: procedure.ProcedureID});

            updateReferences();
        };

        // Section has children
        $scope.sectionHasChildren = function () {
            var nextSection = $scope.getNextSectionBlock($scope.sectionBlock);

            if (!nextSection) return false;

            return nextSection.Depth > $scope.sectionBlock.Depth;
        };

        // Init
        if ($scope.sectionBlock.SectionBlockID) {
            procedureService
                .getSectionBlock(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.sectionBlock.ProcedureID,
                    $scope.sectionBlock.SectionBlockID)
                .then(function (sectionBlock) {
                    $scope.sectionBlock = sectionBlock;
                    initSectionBlock();
                });
        } else {
            $scope.sectionBlock = _.cloneDeep($scope.sectionBlock);
            initSectionBlock();
        }

        function initSectionBlock() {
            $scope.sectionBlock._isEditing = true;
            initReferences();
            initInlineReferences();
            $scope.setLanguage($scope.ctxtCtrl.langAttr);
        }

        function initReferences() {
            $scope.sectionBlock.AttachmentReferences    = $scope.sectionBlock.AttachmentReferences || [];
            $scope.sectionBlock.BusinessUnitReferences  = $scope.sectionBlock.BusinessUnitReferences || [];
            $scope.sectionBlock.ControlReferences       = $scope.sectionBlock.ControlReferences || [];
            $scope.sectionBlock.ImageAttachments        = $scope.sectionBlock.ImageAttachments || [];
            $scope.sectionBlock.LookupReferences        = $scope.sectionBlock.LookupReferences || [];
            $scope.sectionBlock.ProcedureReferences     = $scope.sectionBlock.ProcedureReferences || [];
            $scope.sectionBlock.CorporateRoleReferences = $scope.sectionBlock.CorporateRoleReferences || [];
            $scope.sectionBlock.CommitteeReferences     = $scope.sectionBlock.CommitteeReferences || [];
            $scope.sectionBlock.UrlReferences           = $scope.sectionBlock.UrlReferences || [];
            $scope.sectionBlock.IAMSystemReferences     = $scope.sectionBlock.IAMSystemReferences || [];

            initLookupAttributeValueReferences();
            updateReferences(true);
        }

        function initLookupAttributeValueReferences() {
            // Group lookup attribute values by Lookup Attribute Code and assign to the context object
            var groupedAttrValues =
                    _.groupBy($scope.sectionBlock.LookupReferences, 'LookupAttributeID');

            _.forOwn(groupedAttrValues, function (lookupAttributeValues, lookupAttrId) {
                var lookupAttribute = sectionBlockLookupsByAttributeID[lookupAttrId];

                $scope.sectionCtxtCtrl.lookupReferences[lookupAttribute.Code] = lookupAttributeValues;
            });
        }

        function initInlineReferences() {
            // For each supported inline ref type, mount data in the form of: InlineRefs[ItemType/LookupCode][ID] = {reference}
            $scope.sectionBlock.inlineReferences = {
                BusinessUnit: {},
                Committee: {},
                CorporateRole: {},
                GlossaryTerm: {},
                IAMSystem: {}
            };

            // Business Unit
            _.each($scope.sectionBlock.BusinessUnitReferences, function (businessUnitRef) {
                $scope.sectionBlock.inlineReferences.BusinessUnit[businessUnitRef.BusinessUnitID] = businessUnitRef;
            });

            // Committee
            _.each($scope.sectionBlock.CommitteeReferences, function (committeeRef) {
                $scope.sectionBlock.inlineReferences.Committee[committeeRef.CommitteeID] = committeeRef;
            });

            // Corporate Role
            _.each($scope.sectionBlock.CorporateRoleReferences, function (corporateRoleRef) {
                $scope.sectionBlock.inlineReferences.CorporateRole[corporateRoleRef.CorporateRoleID] = corporateRoleRef;
            });

            // Glossary Term
            _.each($scope.sectionCtxtCtrl.lookupReferences.GlossaryTerm, function (glossaryTermRef) {
                $scope.sectionBlock.inlineReferences.GlossaryTerm[glossaryTermRef.LookupAttributeValueID] = glossaryTermRef;
            });

            // IAM System
            _.each($scope.sectionBlock.IAMSystemReferences, function (iamSystemRef) {
                $scope.sectionBlock.inlineReferences.IAMSystem[iamSystemRef.IAMSystemID] = iamSystemRef;
            });
        }

        function updateFormValidity() {
            var valid = $scope.sectionCtxtCtrl.isTitleRequired
                && $scope.sectionBlock['Title' + $scope.ctxtCtrl.lang];

            if (!valid) {
                // Check if Title or Content is provided in English
                valid = !!$scope.sectionBlock.TitleEN || !!$scope.sectionBlock.Content;
            }

            // Timeout to wait for <form> to be accessible to $scope
            $timeout(function () {
                $scope.procedureSectionBlockForm.$setValidity('NotEmptySectionBlock', valid);
            });
        }

        /**
         * @param skipSetDirty {boolean=false} true to prevent marking the section has changed
         */
        function updateReferences(skipSetDirty) {
            $scope.sectionBlock.Responsibility = null;

            $scope.sectionCtxtCtrl.referenceCount =
                $scope.sectionBlock.AttachmentReferences.length
                + $scope.sectionBlock.ControlReferences.length
                + $scope.sectionCtxtCtrl.lookupReferences.ProcessOutput.length;

            if (!skipSetDirty) {
                $scope.procedureCtxt.hasSectionChanged = true;
            }
        }

        /**
         * Add a footnote to the section-block
         * @param name {string} shortName of the footnote
         * @param content {string} html content of the footnote
         */
        function addFootnote(name, content) {
            $scope.sectionBlock['Footnotes' + $scope.procedureCtxt.lang] =
                $scope.sectionBlock['Footnotes' + $scope.procedureCtxt.lang] || [];

            $scope.sectionBlock['Footnotes' + $scope.procedureCtxt.lang].push({
                Code: name,
                ContentHtml: content,
                LanguageID: $scope.procedureCtxt.langAttr.LookupAttributeValueID
            });
        }

        function addAttachmentReference(toEdit) {
            var attachment = {
                titleEN: null,
                titleFR: null,
                file: null,
                languageID: null
            };

            if (toEdit) {
                attachment.titleEN = toEdit.TitleEN;
                attachment.titleFR = toEdit.TitleFR;
                attachment.languageID = toEdit.LanguageID;
                attachment.fileToEdit = toEdit;
                attachment.uploadedFile = toEdit;

                if (toEdit.LanguageID === $scope.sectionCtxtCtrl.langIdFR) {
                    attachment.titleEN = null;
                }
            }

            var modal;
            modal = modalService.displayTemplateModal(
                'Add an Attachment',
                require('../../../shared/procedure/referenceType/prcAttachment.modal.tpl.html'),
                {
                    attachment: attachment,
                    formCtrl: {},
                    lang: $scope.ctxtCtrl.lang,
                    acceptedFiles: '*',
                    onFileAdded: function (file) {
                        var scope = this;
                        scope.formCtrl.isUploading = true;
                        attachmentService
                            .uploadFile(file)
                            .then(function (file) {
                                if (file.messageSeverity && file.messageSeverity === 'Error') {
                                    scope.attachment.file = null;
                                    scope.attachment.uploadedFile = null;
                                } else {
                                    scope.attachment.uploadedFile = file;
                                }
                            }, function () {
                                scope.attachment.file = null;
                                scope.attachment.uploadedFile = null;
                            })
                            .finally(function () {
                                scope.formCtrl.isUploading = false;
                            });
                    }
                },
                function (scope) {
                    // Validate form
                    var hasTitle = scope.attachment.titleEN || scope.attachment.titleFR;
                    scope.formCtrl.form.$setValidity('TitleProvided', !!hasTitle);

                    scope.formCtrl.form.$setValidity('AttachmentProvided', !!scope.attachment.uploadedFile);

                    if (scope.formCtrl.form.$invalid) return;

                    if (scope.attachment.titleFR) {
                        scope.attachment.uploadedFile.TitleEN = scope.attachment.titleFR;
                        scope.attachment.uploadedFile.TitleFR = scope.attachment.titleFR;

                        scope.attachment.uploadedFile.LanguageID = $scope.sectionCtxtCtrl.langIdFR;
                    } else {
                        scope.attachment.uploadedFile.TitleFR = null;
                    }

                    if (scope.attachment.titleEN) {
                        // When both titles are provided, language is set to EN as we filter en LangID in EN and
                        // on a defined TitleFR en FR as TitleEN is always required.
                        scope.attachment.uploadedFile.TitleEN = scope.attachment.titleEN;
                        scope.attachment.uploadedFile.LanguageID = $scope.sectionCtxtCtrl.langIdEN;
                    }

                    // Editing an attachment
                    if (scope.attachment.fileToEdit) {
                        var attIndex = _.findIndex($scope.sectionBlock.AttachmentReferences, {
                            ItemAttachmentID: scope.attachment.fileToEdit.ItemAttachmentID
                        });
                        $scope.sectionBlock.AttachmentReferences[attIndex] = scope.attachment.uploadedFile;
                    } else {
                        $scope.sectionBlock.AttachmentReferences.push(scope.attachment.uploadedFile);
                    }

                    modal.$promise.then(modal.hide);
                    updateReferences();
                }
            );
        }

        function addControlReference() {
            // Modal to select control
            var modalScope            = $scope.$new(true);
            modalScope.modalTitle     = 'Select a Control';
            modalScope.actualControls = [];

            var selectControlModal = $modal({
                scope: modalScope,
                template: '/app/shared/grc/control/selectControlModal.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function () {
                selectControlModal.$promise.then(selectControlModal.hide);
            };

            modalScope.okModal = function () {
                modalScope.hideModal();
            };

            // Add the selected control
            modalScope.whenSelectControl = function (selectedControl) {
                if (!_.find($scope.sectionBlock.ControlReferences, {ControlID: selectedControl.ControlID})) {
                    $scope.sectionBlock.ControlReferences.push(selectedControl);
                    updateReferences();
                }
                modalScope.okModal();
            };
        }

        function addLookupAttributeReference(lookupAttribute) {
            var curScroll = window.pageYOffset;

            // TODO: update ui-select to force to always display at bottom
            window.scrollTo(0, 0);

            var availableLookups = _.reject(lookupAttribute.LookupAttributeValues, function (lookupAttrVal) {
                return _.find($scope.sectionCtxtCtrl.lookupReferences[lookupAttribute.Code], {

                    LookupAttributeValueID: lookupAttrVal.LookupAttributeValueID
                });
            });

            modalService.displayTemplateModal(
                lookupAttribute.TitleEN,
                require('../../../shared/procedure/referenceType/prcLookupAttributeValue.modal.tpl.html'),
                {
                    availableLookupAttributeValues: availableLookups,
                    selection: {
                        selectedLookup: null
                    },
                    lang: $scope.ctxtCtrl.lang,
                    getValueInLang: function (object, column, lang) {
                        if (_.isNil(object)) return '';

                        return _.get(object, column + lang, object[column+'EN']);
                    },
                    ngStyle: {'min-height': '260px'},
                    placeholderText: availableLookups.length ?
                        'Please select a ' + lookupAttribute.TitleEN
                        : 'No ' + lookupAttribute.TitleEN + ' to select'
                },
                function (scope) {
                    if (scope.selection.selectedLookup) {
                        window.scrollTo(0, curScroll);
                        $scope.sectionCtxtCtrl.lookupReferences[lookupAttribute.Code].push(scope.selection.selectedLookup);

                        // Update model
                        $scope.sectionBlock.LookupReferences.push(scope.selection.selectedLookup);

                        updateReferences();
                        return true;
                    }
                    return false;
                },
                true,
                function () {
                    window.scrollTo(0, curScroll);
                }
            );
        }

        function manageProcedureVersionChanged(sectionBlock) {
            if ($scope.procedure.ProcedureID !== sectionBlock.ProcedureID) {
                $state.reload();
                return true;
            }
            return false;
        }
    }
})();
